module.exports = __webpack_public_path__ + "media/images/pic/brodno/exam-5cdeedadefa9693171b82df6602a19e8.jpg";